const apiBase = import.meta.env.VITE_PUBLIC_API_URL || '';

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${apiBase}${path}`, {
    ...options,
    headers: {
      'content-type': 'application/json',
      ...(options.headers ?? {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof body.error === 'string' ? body.error : 'Une erreur est survenue.');
    if (typeof body.code === 'string') {
      Object.assign(error, { code: body.code });
    }
    throw error;
  }
  return body as T;
}
